import { render, staticRenderFns } from "./ContributionTip.vue?vue&type=template&id=713dabfc&scoped=true&"
import script from "./ContributionTip.vue?vue&type=script&lang=js&"
export * from "./ContributionTip.vue?vue&type=script&lang=js&"
import style0 from "./ContributionTip.vue?vue&type=style&index=0&id=713dabfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713dabfc",
  null
  
)

export default component.exports